namespace Cfnc {
    "use strict";

    interface ICfncMmenuLink extends ng.IDirective {

    }

    interface ICfncMmenuLinkScope extends ng.IScope {
        menu: any;
    }

    declare const Mmenu: any;


    export class CfncMmenuLink implements ICfncMmenuLink {
        static directiveId: string = "cfncMmenuLink";
        require: "^cfncMmenu"
        restrict: string = "A";
        replace: boolean = false;

        constructor(private $location: ng.ILocationService) {

        }

        link = (scope: ICfncMmenuLinkScope, element: ng.IAugmentedJQuery, attrs: any) => {
            var path = attrs.cfncMmenuLink;

            // KC: This needs replaced. The cfncMMenu directive needs to expose a function that will do this and bind it to the menu button
            element.click(() => {
                $("#menuBtn").toggleClass("active");
                $("body").toggleClass("state-scroll-blocked");
                $(".mobile-menu").fadeToggle();
                this.$location.path(path);
                scope.$apply();
            });

        }

    }


    angular.module("app").directive(CfncMmenuLink.directiveId, ["$location", ($location) => new CfncMmenuLink($location)]);
}